import React, { useEffect, useRef, useState } from "react";
import logo from "../assets/logo/Logo.svg";
import google from "../assets/logo/Google.svg";
import facebook from "../assets/logo/Facebook.svg";
import apple from "../assets/logo/apple.png";
import Carousel from "../components/carousel/logincarousel";
import loginbanner from "../assets/images/login-banner.png";
import loginbannertwo from "../assets/images/login-banner-2.png";
import loginbannerthree from "../assets/images/login-banner-3.png";
import loginbannerfour from "../assets/images/login-banner-4.png";
import loginbannersm from "../assets/images/login-banner-sm.png";
import bannerlayout from "../assets/images/banner-layout.png";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const OTP_EXPIRY_SECONDS = 5 * 60;
export default function VerifyCode() {
  const [code, setCode] = useState("");
  const [error, setError] = useState(null);
  const [resendTimer, setResendTimer] = useState(0);
  const [isResending, setIsResending] = useState(false);
  const navigate = useNavigate(); // Hook for navigation
  const API_URL = `${API_BASE_URL}/auth`;
  const timerRef = useRef(null);

  const formatTime = (seconds) => {
    const minutes = String(Math.floor(seconds / 60)).padStart(2, "0");
    const remainingSeconds = String(seconds % 60).padStart(2, "0");
    return `${minutes}:${remainingSeconds}`;
  };

  const startResendTimer = (initialSeconds = OTP_EXPIRY_SECONDS) => {
    const expiresAt = Date.now() + initialSeconds * 1000;
    sessionStorage.setItem("resendOtpExpiresAt", String(expiresAt));
    setResendTimer(initialSeconds);

    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setResendTimer((previousTimer) => {
        if (previousTimer <= 1) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          sessionStorage.removeItem("resendOtpExpiresAt");
          return 0;
        }
        return previousTimer - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    const storedExpiry = sessionStorage.getItem("resendOtpExpiresAt");
    const secondsRemaining = storedExpiry
      ? Math.ceil((Number(storedExpiry) - Date.now()) / 1000)
      : 0;

    if (secondsRemaining > 0) {
      startResendTimer(secondsRemaining);
    } else {
      sessionStorage.removeItem("resendOtpExpiresAt");
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
    // The timer should be initialized only when this screen mounts.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ Handle Resend OTP
  const handleResendOTP = async (e) => {
    e.preventDefault();
    setError(null);
    if (resendTimer > 0 || isResending) return;
    const storedEmail = sessionStorage.getItem("userEmail");

    if (!storedEmail) {
      toast.error("No email found. Please sign up again.");
      return;
    }

    setIsResending(true);
    try {
      const response = await fetch(`${API_URL}/forget-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: storedEmail }),
      });

      const data = await response.json();
      console.log("Resend OTP Response:", data);

      if (response.ok && data.success) {
        if (data.result?.data) {
          sessionStorage.setItem("resetToken", data.result.data);
          localStorage.setItem("resetToken", data.result.data);
          console.log("New Reset Token stored:", data.result.data);
        }
        toast.success("A new OTP has been sent to your email.");
        setCode("");
        startResendTimer();
      } else {
        setError(data.message || "Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      setError("Something went wrong. Please try again.");
    } finally {
      setIsResending(false);
    }
  };
const [isVerifying, setIsVerifying] = useState(false);

  // ✅ Handle OTP Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
 // 🚫 Prevent multiple clicks
  if (isVerifying) return;

  setIsVerifying(true);
  setError(null);
    if (resendTimer === 0) {
      setCode("");
      setError("This OTP has expired. Please request a new OTP.");
      setIsVerifying(false);
      return;
    }
    const token = sessionStorage.getItem("resetToken");
    if (!token) {
      setError("Session expired. Please request a new OTP.");
          setIsVerifying(false);

      return;
    }

    try {
      const response = await fetch(`${API_URL}/validate-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, otp: code }),
      });

      const data = await response.json();
      console.log("API Response:", data);

      if (response.ok && data.success) {
        sessionStorage.setItem("otp", data.result?.otp || "");
        localStorage.setItem("otp", data.result?.otp || "");
        toast.success("✅ OTP Verified! Redirecting...");
        navigate("/resetpassword");
      } else {
        // ✅ Show the exact error message from API response
        setError(data.message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      setError("Something went wrong. Please try again.");
    }finally {
    // ✅ Always reset loading state
    setIsVerifying(false);
  }
};

  return (
    <div className="login">
      <div className="container min-h-screen flex">
        {/* Left Side Image */}
        <div className="hidden lg:block lg:w-1/2">
          <div className="carousel-size pb-3 pt-3">
            <Carousel slides={[loginbanner, loginbannertwo, loginbannerthree, loginbannerfour]} />
            <img src={bannerlayout} alt="Overlay" className="layout" />
          </div>
          <div className="copy-rights py-6 text-center text-sm text-[#095228]">
            © 2025 Pipaan. All Rights Reserved
          </div>
        </div>

        {/* Right Side Form */}
        <div className="w-full lg:w-1/2 login-content flex flex-col">
          <div className="login-form">
            {/* Header */}
            <div className="reset-pass flex flex-col items-center justify-center px-6">
              <div className="logo">
                <img src={logo} alt="Pipaan Logo" width={150} height={50} />
              </div>

              <div className="w-full max-w-md">
                <h1 className="login-title text-2xl font-semibold text-left mb-2">Verify Code</h1>
                <p className="text-left text-[#313131] text-sm mb-8">
                  An authentication code has been sent to your email.
                </p>

                {/* ✅ Verification Form */}
                <form onSubmit={handleSubmit} className="space-y-4 mb-10">
                  <div className="w-full relative mb-5 reset-pass-content">
                    <input
                      type="text"
                      placeholder="Enter Verification Code"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      className="w-full h-12 px-4 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>

                  {/* ✅ Display API Error Message */}
                  {error && <p className="text-red-500 text-sm">{error}</p>}

                  <p className="text-lg font-bold text-[#BE1F2E] text-center">
                    {formatTime(resendTimer)}
                  </p>

                  <button type="submit"    disabled={isVerifying}
                    className={`w-full py-3 rounded-xl font-medium text-white
                      ${isVerifying ? "bg-gray-400 cursor-not-allowed" : "bg-[#1B2537]"}`}
                  >
                    {isVerifying ? "Verifying..." : "Verify OTP"}
                  </button>
                </form>

                {/* Resend OTP */}
                <p className="text-sm text-[#313131] text-center">
                  Didn’t receive a code?{" "}
                  <button
                    type="button"
                    className={`text-[#006838] font-medium ${resendTimer === 0 && !isResending ? "hover:underline" : "opacity-50 cursor-not-allowed"}`}
                    onClick={handleResendOTP}
                    disabled={resendTimer > 0 || isResending}
                  >
                    {resendTimer > 0 ? `Resend (${formatTime(resendTimer)})` : (isResending ? "Resending..." : "Resend")}
                  </button>
                </p>

                {/* Social Login */}
                <div className="relative my-6">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t-2 border-gray-200"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="bg-white px-2 text-gray-500">Login With</span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-10 mx-auto w-fit">
                  <button className="w-full rounded-lg p-2">
                    <img src={google} alt="Google" className="mx-auto" />
                  </button>
                  <button className="w-full rounded-lg p-2">
                    <img src={facebook} alt="Facebook" className="mx-auto" />
                  </button>
                  {/* <button className="w-full rounded-lg p-2">
                    <img src={apple} alt="Apple" className="mx-auto" />
                  </button> */}
                </div>

                {/* Signup Link */}
                <p className="text-center text-sm text-[#313957] mt-4">
                  Don't have an account?{" "}
                  <Link to="/signup" className="text-[#006838] font-semibold hover:underline">
                    Create New Account
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
